<template>
  <img
    v-if="src"
    :src="src"
    :alt="label"
    :title="label"
    :width="size"
    :height="size"
    class="level-marker"
  />
</template>

<script>
  import markerLow from "@/assets/brand/markers/marker-low.svg";
  import markerGood from "@/assets/brand/markers/marker-good.svg";
  import markerHigh from "@/assets/brand/markers/marker-high.svg";
  import { levelKey, levelLabel } from "@/utils/levelStatus";

  const MARKERS = { low: markerLow, good: markerGood, high: markerHigh };

  // Station marker of the brand (docs/BRAND.md) for a section's level: bas, bon or haut. Nothing when unknown.
  // Show it only where the level itself is shown: the level is for members unless the section is free access.
  export default {
    name: "LevelMarker",
    props: {
      // sections.level_status
      status: {
        type: String,
        default: "",
      },
      size: {
        type: Number,
        default: 20,
      },
    },
    computed: {
      src() {
        const key = levelKey(this.status);
        return key ? MARKERS[key] : null;
      },
      label() {
        return levelLabel(this.status);
      },
    },
  };
</script>

<style scoped>
  .level-marker {
    display: inline-block;
    flex: none;
    vertical-align: middle;
  }
</style>
